import { RouterProvider } from 'react-router-dom'
import { ThemeProvider, createTheme, CssBaseline, IconButton } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from "@fortawesome/pro-light-svg-icons"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { SnackbarProvider, closeSnackbar } from "notistack"
import { router } from './core/router/router'
import { AppLocalizationProvider } from './modules/localization/components/AppLocalizationProvider'
import { useLogVersionBanner } from './modules/environment/components/AppVersion'
import { Provider as ReduxProvider } from "react-redux"
import { queryClient } from './core/api/queryClient'
import { store } from './modules/store/store'
import { MuiLocalizationProvider } from './modules/localization/components/MuiLocalizationProvider'


export const App = () => {
    // Here we set the themes for Material UI
    // TODO talk to Jeppe in terms of themes and show him the theme object https://mui.com/material-ui/customization/default-theme/
    const theme = createTheme({
        typography: {
            subtitle1: {
                fontWeight: 500
            }
        }
    })

    useLogVersionBanner()

    return (
        <ReduxProvider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "bottom" }} hideIconVariant preventDuplicate action={(key) => (
                    <IconButton onClick={() => closeSnackbar(key)}><FontAwesomeIcon icon={faClose} size="xs" color="white" /></IconButton>
                )}>
                    <AppLocalizationProvider>
                        <MuiLocalizationProvider>
                            <QueryClientProvider client={queryClient}>
                                <RouterProvider router={router} />
                                <ReactQueryDevtools initialIsOpen={false} />
                            </QueryClientProvider>
                        </MuiLocalizationProvider>
                    </AppLocalizationProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </ReduxProvider>
    )
}
